import mermaid from "mermaid";
import { useEffect, useState } from "react";

mermaid.initialize({ startOnLoad: false });

const Mermaid = ({ name = "mermaid", children, className }) => {
  const [diagram, setDiagram] = useState("Loading diagram...");

  useEffect(() => {
    mermaid.mermaidAPI.render(name, children.toString(), (svgCode) =>
      setDiagram(svgCode)
    );
  }, [name, children]);

  return (
    <div
      className={`mermaid ${className}`}
      dangerouslySetInnerHTML={{ __html: diagram }}
    />
  );
};
export default Mermaid;
